import React, { useEffect } from 'react'
import Skeleton from 'react-loading-skeleton';
import ToastMessage from '../../../../common/ToastMessage';
import useStatusById from '../../../../store/ReactQueries/statuses/useStatusById';
import useLocationsById from '../../../../store/ReactQueries/locations/useLocationById';
import useCategoryById from '../../../../store/ReactQueries/categories/useCategoryById';
import usePriorityById from '../../../../store/ReactQueries/priorities/usePriorityById';
import useCustomersById from '../../../../store/ReactQueries/customers/useCustomersById';
import useDepartmentById from '../../../../store/ReactQueries/departments/useDepartmentById';
import useContractorById from '../../../../store/ReactQueries/contractors/useContractorById';
import useInterventionTypeById from '../../../../store/ReactQueries/interventionTypes/useInterventionTypeById';
import { useDarkModeStore } from '../../../../store/useDarkModeStore';
import { useLanguageStore } from '../../../../store/useLanguageStore';
import { UserGlobalFilter } from '../../../../models/UserModel/UserGlobalFilter';

interface GlobalFilterViewInputProps {
    loading: boolean;
    globalFilter: UserGlobalFilter;
}

const useDataByFieldName = (fieldName: string, value: string) => {
    const hooksMap: Record<string, () => any> = {
        StatusId: () => useStatusById(value),
        LocationId: () => useLocationsById(value),
        CustomerId: () => useCustomersById(value),
        CategoryId: () => useCategoryById(value),
        PriorityId: () => usePriorityById(value),
        DepartmentId: () => useDepartmentById(value),
        ContractorId: () => useContractorById(value),
        InterventionTypeId: () => useInterventionTypeById(value),
    };

    return hooksMap[fieldName]?.() || {};
};

export const GlobalFilterViewInput: React.FC<GlobalFilterViewInputProps> = ({ globalFilter, loading }) => {
    const { fieldName, value } = globalFilter;
    const label = fieldName.replace(/Id$/, '');

    const { darkMode } = useDarkModeStore();
    const { language } = useLanguageStore();
    const { data, error } = useDataByFieldName(fieldName, value);

    useEffect(() => {
        if (error) ToastMessage.Failed(`Error: ${error.message}`);
    }, [error]);

    return loading
        ? <div
            key={fieldName + '-global-filter-input'}
            className='form form-group'
        >
            <Skeleton className='mb-2' style={{ width: 80, height: 24 }} />
            <Skeleton style={{ width: '100%', height: 50 }} />
        </div>
        : <div
            key={fieldName + '-global-filter-input'}
            className='form form-group'
        >
            <label
                htmlFor={fieldName}
                className='fw-bold mb-2'
                style={{ color: darkMode ? 'white' : 'initial' }}
            >
                {language[label] ?? fieldName}
            </label>
            <input
                id={fieldName}
                disabled
                style={{ height: 50 }}
                value={data?.title ?? ''}
                className={`form form-control grid-input-profile ${darkMode && 'grid-input-profile-dark-mode'}`}
            />
        </div>
}
export default GlobalFilterViewInput;